import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import MobileSidebar from "../../Dashboard/DashboardHeader/MobileSidebar/MobileSidebar";
import "./landing-header.style.scss";
export default function LandingHeader({ opaque, candidateLanding, help }) {
  const history = useHistory();
  const context = React.useContext(MainContext);
  const [contentInside, setContentInside] = React.useState("");
  const { userDetails, updateState, userType } = context;
  const [dropdown, setDropdown] = React.useState(false);
  const handleClick = (obj) => {
    if (userType === "candidate") {
      switch (obj.id) {
        case "myProfile":
          history.push("/user/profile");
          break;
        case "logout":
          updateState("appliedJobs", []);
          updateState("savedJobs", []);
          updateState("userDetails", null);
          localStorage.clear();

          break;
        case "saved-jobs":
          history.push("/user/list/saved-jobs");
          break;

        case "recommended-jobs":
          history.push("/user/list/recommended-jobs");
          break;
        case "applied-jobs":
          history.push("/user/list/applied-jobs");
          break;

        default:
          break;
      }
    } else {
      switch (obj.id) {
        case "saved-application":
        case "jobs-list":
          history.push("/institute");
          break;
        case "myProfile":
          history.push("/institute/profile");
          break;
        case "logout":
          updateState("appliedJobs", []);
          updateState("savedJobs", []);
          updateState("userDetails", null);
          localStorage.clear();

          break;

        default:
          break;
      }
    }
  };
  return (
    <>
      <header className={`landing-header-main ${opaque}`}>
        <nav>
          <Link to="/">
            <img src={Images.mainLogo} alt="main" />
          </Link>
          <ul>
            {headerList.map((obj) => (
              <li
                style={
                  obj.val === candidateLanding
                    ? { textDecoration: "underline" }
                    : {}
                }
              >
                <Link key={obj.keyId} to={`/${obj.id}`}>
                  {obj.name}
                  {obj.count && `(${obj.count})`}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="dhm-right">
          <div className="dhmr-left">
            <div className="notification-wrapper">
              <p>Also available in</p>
              <img height="35px" src={Images.newPlayStore} />
              <img height="35px" src={Images.newAppStoreX} />
            </div>
          </div>
          {/* src="https://img.icons8.com/material-sharp/50/ffffff/sort-down.png" */}
          <div className="dhmr-right">
            {!userDetails ? (
              <Link to="/login" className="dhmr-login">
                <img src={Images.loginLogo} />
                <span> Login/Register</span>
              </Link>
            ) : (
              <div className="dhmr-logged ">
                <img
                  className="dp"
                  height="20px"
                  onError={(e) =>
                    (e.target.src =
                      "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png")
                  }
                  src={
                    userDetails?.candidate_img ||
                    "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                  }
                />
                <p className="username">
                  {userType === "candidate"
                    ? userDetails?.candidate_full_name || "NA"
                    : userDetails.institution_name || "NA"}
                </p>
                {/* <img
                  className="arrow"
                  src="https://img.icons8.com/material-sharp/50/ffffff/sort-down.png"
                /> */}

                <div className="dhmr-dropdown">
                  <div className="dhmrd-header">
                    <img
                      onError={(e) =>
                        (e.target.src =
                          "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png")
                      }
                      src={
                        userDetails?.candidate_img ||
                        "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                      }
                    />
                    <div>
                      <h6>
                        {userType === "candidate"
                          ? userDetails?.candidate_full_name || "NA"
                          : userDetails.institution_name || "NA"}
                      </h6>
                      <p>
                        {userType === "candidate"
                          ? userDetails?.institution_primary_email
                          : userDetails.institution_primary_email}
                      </p>
                    </div>
                  </div>
                  {dropdownLists?.[userType]?.map((obj) => (
                    <ul key={obj.keyId}>
                      {obj.list.map((x) => (
                        <li onClick={() => handleClick(x)} key={x.keyId}>
                          {x.name}
                        </li>
                      ))}
                    </ul>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <header className="landing-header-main-mobile">
        <nav className="dhmm-at-display">
          <img src={Images.mainLogo} />
          <button
            onClick={() => setContentInside("home")}
            className="dhmmad-button"
          >
            <img src="https://img.icons8.com/material-rounded/48/000000/menu--v1.png" />
          </button>
        </nav>
        {contentInside && (
          <MobileSidebar
            setContentInside={setContentInside}
            content={contentInside}
            userDetails={userDetails}
          />
        )}
      </header>
    </>
  );
}

const headerList = [
  { keyId: nextId(), name: "Candidate", id: "candidate", val: true },
  { keyId: nextId(), name: "Institution", id: "institution", val: false },
];
const dropdownLists = {
  candidate: [
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "My Profile", id: "myProfile" }],
    },
    {
      keyId: nextId(),
      list: [
        { keyId: nextId(), name: "Recommended Jobs", id: "recommended-jobs" },
        { keyId: nextId(), name: "Saved Jobs", id: "saved-jobs" },
        { keyId: nextId(), name: "Applied Jobs", id: "applied-jobs" },
      ],
    },
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "Notifications", id: "notification" }],
    },
    {
      keyId: nextId(),
      list: [
        { keyId: nextId(), name: "Help", id: "help" },
        { keyId: nextId(), name: "Feedback", id: "fb" },
      ],
    },
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "Log Out", id: "logout" }],
    },
  ],

  institution: [
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "My Profile", id: "myProfile" }],
    },
    {
      keyId: nextId(),
      list: [
        { keyId: nextId(), name: "jobs List", id: "jobs-list" },
        { keyId: nextId(), name: "Saved Application", id: "saved-application" },
      ],
    },
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "Notifications", id: "notification" }],
    },
    {
      keyId: nextId(),
      list: [
        { keyId: nextId(), name: "Help", id: "help" },
        { keyId: nextId(), name: "Feedback", id: "fb" },
      ],
    },
    {
      keyId: nextId(),
      list: [{ keyId: nextId(), name: "Log Out", id: "logout" }],
    },
  ],
};
